import Swiper from 'swiper';

// TODO: refactor!!!
(($) => {
  const textHolder = $('#past-events-swiper-text-wrapper');

  const eventText1 = $('#past-event-text-1');
  const eventText2 = $('#past-event-text-2');
  const eventText3 = $('#past-event-text-3');
  const eventText4 = $('#past-event-text-4');

  $(eventText1).mouseover(() => {
    highlight(eventText1, 1);
  });
  $(eventText2).mouseover(() => {
    highlight(eventText2, 2);
  });
  $(eventText3).mouseover(() => {
    highlight(eventText3, 3);
  });
  $(eventText4).mouseover(() => {
    highlight(eventText4, 4);
  });

  const mySwiper = new Swiper('.past-events-swiper-container', {
    loop: true,
    speed: 300,
    spaceBetween: 0,
    autoplay: false,
    simulateTouch: false,

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  function highlight(eventText, number) {
    $(eventText1).removeClass('active');
    $(eventText2).removeClass('active');
    $(eventText3).removeClass('active');
    $(eventText4).removeClass('active');

    $(eventText).addClass('active');

    mySwiper.slideTo(number, 300);

    const text = $(eventText).find('.past-event-text-content').text();
    $(textHolder).empty();
    $(textHolder).append('<p>' + text + '</p>');
  }

  function highlightText(eventText) {
    $(eventText1).removeClass('active');
    $(eventText2).removeClass('active');
    $(eventText3).removeClass('active');
    $(eventText4).removeClass('active');

    $(eventText).addClass('active');

    const text = $(eventText).find('.past-event-text-content').text();
    $(textHolder).empty();
    $(textHolder).append('<p>' + text + '</p>');
  }

  mySwiper.on('slideChange', () => {
    setTimeout(() => {
      let number = parseInt($('.swiper-slide-active').data('swiper-slide-index'), 10);
      number++;

      if (number === 1) {
        highlightText(eventText1);
      } else if (number === 2) {
        highlightText(eventText2);
      } else if (number === 3) {
        highlightText(eventText3);
      } else if (number === 4) {
        highlightText(eventText4);
      }
    }, 300);
  });
  /* eslint-disable-next-line no-undef */
})(jQuery);
